import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { borrowingQuotaShape } from '@bibliocommons/bc-prop-types';
import BCReactComponent from '@bibliocommons/base-bc-react-component';

import BorrowingUtilityBarTitle from '../../shared/BorrowingUtilityBarTitle';
import BorrowingUtilityBar from '../../shared/BorrowingUtilityBar';
import CheckedOutStatusIcon from '../CheckedOutStatusIcon';

import MaterialTypeFilterLinks from '../../shared/MaterialTypeFilterLinks';
import CheckedOutQuotasPopOver from '../CheckedOutQuotasPopOver';

import './CheckedOutUtilityBar.scss';

export default class CheckedOutUtilityBar extends BCReactComponent {
  canFilter() {
    const { materialTypeCounts } = this.props;
    return materialTypeCounts &&
      materialTypeCounts.get('DIGITAL', 0) > 0 &&
      materialTypeCounts.get('PHYSICAL', 0) > 0;
  }

  renderIcon() {
    return this.props.status && <CheckedOutStatusIcon status={this.props.status} withBackground />;
  }

  renderTitle() {
    const showFilterLinks = this.canFilter();
    return (
      <div>
        <BorrowingUtilityBarTitle
          status={this.props.status}
          statusIcon={this.renderIcon()}
          count={this.props.totalCount} />
        {showFilterLinks && <MaterialTypeFilterLinks
          totalCount={this.props.totalCount}
          materialTypeCounts={this.props.materialTypeCounts} />}
        {this.props.allItemsDigital && <CheckedOutQuotasPopOver quotas={this.props.quotas} />}
      </div>
    );
  }

  render() {
    return (
      <BorrowingUtilityBar
        className="cp-checked-out-utility-bar"
        title={this.renderTitle()}
        printURL={this.props.printURL}
        pagination={this.props.pagination}
        sortOptions={this.props.sortOptions} />
    );
  }
}

CheckedOutUtilityBar.propTypes = {
  allItemsDigital: PropTypes.bool,
  status: PropTypes.string,
  totalCount: PropTypes.number,
  materialTypeCounts: ImmutablePropTypes.mapContains({
    PHYSICAL: PropTypes.number,
    DIGITAL: PropTypes.number
  }),
  sortOptions: ImmutablePropTypes.list,
  handleSort: PropTypes.func,
  printURL: PropTypes.string,
  quotas: ImmutablePropTypes.listOf(borrowingQuotaShape),
  pagination: ImmutablePropTypes.map
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/CheckedOutUtilityBar/CheckedOutUtilityBar.jsx